/// <reference path="../types/index.d.ts" />

import '../client_forms/celebritycatering/style.css';
import FormStructure from './celebritycatering/form_structure';

export default FormStructure;